var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackupSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 1.5H1.5V2V16V16.5H2H16H16.5V16V2V1.5H16H2ZM8.19665 10.5104L13.5 5.20711L14.293 6.00007L8.00253 12.2928L4.46709 8.75739L5.16475 8.05968L7.48033 10.501L7.83363 10.8735L8.19665 10.5104ZM1 0.5H17C17.2762 0.5 17.5 0.723856 17.5 1V17C17.5 17.2762 17.2762 17.5 17 17.5H1C0.723856 17.5 0.5 17.2762 0.5 17V1C0.5 0.723862 0.723862 0.5 1 0.5Z",
    stroke: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 336",
    d: "M5 7L3.5 8.5L8 13L15 6L13.5 4.5L8 10L5 7Z",
    fill: "#FBBC05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackupSuccess);
export default __webpack_public_path__ + "static/media/backupSuccess.60fd3de68fde20ab204bb0d4f77c14e5.svg";
export { ForwardRef as ReactComponent };